import api from './client';

// Ritual API - Ritual templates and statistics
export const ritualAPI = {
  // Templates
  getTemplates: () => api.get('/rituals/templates'),
  getTemplatesByCategory: (category: string) =>
    api.get(`/rituals/templates/category/${category}`),
  getTemplate: (id: number) => api.get(`/rituals/templates/${id}`),
  createTemplate: (data: {
    name: string;
    description?: string;
    category?: 'morning' | 'evening' | 'throughout_day' | 'weekly' | 'intimate' | 'custom';
    defaultTitle?: string;
    defaultDescription?: string;
    suggestedTime?: string;
    suggestedDays?: number[];
    durationMinutes?: number;
    requiresPhoto?: boolean;
    requiresVideo?: boolean;
    requiresTextResponse?: boolean;
    textPrompt?: string;
    trackStreak?: boolean;
  }) => api.post('/rituals/templates', data),
  updateTemplate: (id: number, data: {
    name?: string;
    description?: string;
    category?: string;
    defaultTitle?: string;
    defaultDescription?: string;
    suggestedTime?: string;
    suggestedDays?: number[];
    durationMinutes?: number;
    requiresPhoto?: boolean;
    requiresVideo?: boolean;
    requiresTextResponse?: boolean;
    textPrompt?: string;
    trackStreak?: boolean;
  }) => api.put(`/rituals/templates/${id}`, data),
  deleteTemplate: (id: number) => api.delete(`/rituals/templates/${id}`),

  // Statistics
  getMyStats: () => api.get('/rituals/stats/me'),
  getLeaderboard: (limit?: number) =>
    api.get('/rituals/leaderboard', { params: limit ? { limit } : undefined }),
};
